import { ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";

import type { FormActionsProps } from "../types";
import { useTranslations } from "next-intl";

export function FormActions({
	schema,
	currentStepIndex,
	fieldsLength,
	isMultiStep,
	onNextStep,
}: FormActionsProps) {

	const t = useTranslations("builder");	if (fieldsLength === 0) return null;

	const isLastStep =
		!isMultiStep || currentStepIndex === (schema.blocks?.length || 1) - 1;

	return (
		<div className="flex items-center justify-between gap-4">
			{isLastStep ? (
				<Button className="w-full sm:w-auto" type="submit">
					{schema.settings.submitText || t("submit")}
				</Button>
			) : (
				<Button className="flex items-center gap-2" onClick={onNextStep}>
					{t("continueToNextStep")}
					<ChevronRight className="size-4" />
				</Button>
			)}
		</div>
	);
}
